import { ColumnDef } from '@tanstack/react-table';
import AdvanceTable from 'components/base/AdvanceTable';
import AdvanceTableFooter from 'components/base/AdvanceTableFooter';
import RevealDropdown, {
  RevealDropdownTrigger
} from 'components/base/RevealDropdown';
import ActionDropdownItems from './ActionDropdownItems';
import Badge from 'components/base/Badge';
import { User } from '../users.type';
import CanAccess from 'components/modules/auth/Access/CanAccess';

type ColumnArg = {
  onEdit: (row: User) => void;
  onAccountStatusChange: (row: User) => void;
  onDelete: (row: User) => void;
  onInvite: (row: User) => void;
};

export function getUserTablecolumns({
  onEdit,
  onAccountStatusChange,
  onDelete,
  onInvite
}: ColumnArg): ColumnDef<User>[] {
  return [
    {
      accessorKey: 'username',
      header: 'User',
      meta: {
        headerProps: { style: { width: 'fit-content' } },
        cellProps: { className: 'white-space-nowrap py-4' }
      }
    },
    {
      header: 'Email Address',
      accessorKey: 'email',
      meta: {
        headerProps: { style: { width: 'fit-content' } },
        cellProps: { className: 'white-space-nowrap py-4' }
      }
    },
    {
      header: 'Roles',
      accessorKey: 'roles',
      cell: ({ row: { original } }) => {
        const { roles } = original;
        const value =
          Array.isArray(roles) && roles.length > 0
            ? roles.map(({ name }) => name).join(', ')
            : '-';
        return <div>{value}</div>;
      },
      meta: {
        headerProps: { style: { width: 'fit-content' } },
        cellProps: { className: 'white-space-nowrap py-4' }
      }
    },
    {
      id: 'status',
      header: 'Status',
      cell: ({ row: { original } }) => {
        const { isActive } = original;
        return (
          <Badge variant="phoenix" bg={isActive ? 'success' : 'warning'}>
            {isActive ? 'Active' : 'In-Active'}
          </Badge>
        );
      },
      meta: {
        cellProps: { className: 'ps-8 py-4' },
        headerProps: { style: { width: 'fit-content' }, className: 'ps-8' }
      }
    },
    {
      id: 'action',
      cell: ({ row: { original } }) => {
        return (
          <CanAccess action="canUpdate" entity="user">
            <RevealDropdownTrigger>
              <RevealDropdown>
                <ActionDropdownItems
                  onEdit={onEdit}
                  row={original}
                  onAccountStatusChange={onAccountStatusChange}
                  onDelete={onDelete}
                  onInvite={onInvite}
                />
              </RevealDropdown>
            </RevealDropdownTrigger>
          </CanAccess>
        );
      },
      meta: {
        headerProps: { style: { width: '10%' }, className: 'text-center' },
        cellProps: { className: 'text-center' }
      }
    }
  ];
}

const UserTable = () => {
  return (
    <div className="border-bottom border-translucent">
      <AdvanceTable
        tableProps={{
          className: 'phoenix-table fs-9'
        }}
      />
      <AdvanceTableFooter pagination className="py-3" />
    </div>
  );
};

export default UserTable;
